import { render } from "./GridLoader.vue?vue&type=template&id=cb86e0ae&scoped=true"
import script from "./GridLoader.vue?vue&type=script&lang=js"
export * from "./GridLoader.vue?vue&type=script&lang=js"

import "./GridLoader.vue?vue&type=style&index=0&id=cb86e0ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb86e0ae"]])

export default __exports__